import { ListTodo } from 'lucide-react'
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@atrvd/saas-ui'

interface ManageProjectionsButtonProps {
  /** The facility or pack name. */
  columnName: string
  rowLabel: string
  periodLabel: string
  onClick: () => void
}

/**
 * The "Manage projections" icon of a facility or pack cell. Its accessible name carries column,
 * row and period, since the report shows many of them.
 */
export function ManageProjectionsButton({ columnName, rowLabel, periodLabel, onClick }: ManageProjectionsButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={onClick}
          aria-label={`Manage projections — ${columnName}, ${rowLabel}, ${periodLabel}`}
          className="h-6 w-6 shrink-0"
        >
          <ListTodo className="h-3.5 w-3.5" aria-hidden="true" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">Manage projections</TooltipContent>
    </Tooltip>
  )
}
